// extracted by mini-css-extract-plugin
export default {"accordion":"Folder_accordion__Orz7X","accordionDeactivate":"Folder_accordionDeactivate__zdQd4","itemFilter":"Folder_itemFilter__FNhXZ","itemCourse":"Folder_itemCourse__bgVog"};